var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.activities")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col right" }, [
          _c(
            "div",
            { staticClass: "action" },
            [
              _c("base-dropdown-filter-date-range", {
                attrs: {
                  type: _vm.dateType,
                  range: { start: _vm.query.startDate, end: _vm.query.endDate },
                  active: _vm.isAppliedFilter,
                  filterHeader: false
                },
                on: { onSubmit: _vm.handleSubmitFilter }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
          : _vm._e(),
        _vm._v(" "),
        _vm.ready
          ? _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-lg-4 ml-auto" }, [
                _c(
                  "label",
                  { staticClass: "d-flex d-flex align-items-center" },
                  [
                    _c("span", { staticClass: "mr-2" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.search")) +
                          ":\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("base-input", {
                      attrs: {
                        placeholder: _vm.$t(
                          "placeholder.searchstockactivities"
                        ),
                        type: "text",
                        clear: ""
                      },
                      on: {
                        onEnter: _vm.handleSearchEnter,
                        onClear: _vm.handleSearchClear
                      },
                      model: {
                        value: _vm.query.q,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "q", $$v)
                        },
                        expression: "query.q"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.ready
          ? _c("base-table", {
              attrs: { pagination: _vm.$store.state.app.pagination },
              on: { onPageChange: _vm.handlePageChange },
              scopedSlots: _vm._u(
                [
                  {
                    key: "thead",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v(_vm._s(_vm.$t("message.item")))]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("message.inputfrom")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.inventory.message.stockinout")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v(_vm._s(_vm.$t("message.store")))]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.$t("apps.inventory.message.bin"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("message.reference")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("message.saveddate")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$t("message.createdby")))
                            ])
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tbody",
                    fn: function() {
                      return [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _vm.activities.length === 0
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "7" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("message.notfounddata")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.activities, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c(
                                  "td",
                                  [
                                    _c("router-link-custom", {
                                      attrs: {
                                        to: {
                                          name: "ProductEdit",
                                          query: {
                                            pid: item.product.product_id,
                                            pname: item.product.product_name
                                          }
                                        },
                                        text: _vm.getProductFullName(
                                          item.product.product_name,
                                          item.sku.attributes
                                        ),
                                        to_appid: 2,
                                        current_appid: 3,
                                        disabled: item.sku.is_deleted == true
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    [
                                      item.stockactivity.details.reason == "pos"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonpos"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "recipe"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonrecipe"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason == "gr"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasongr"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason == "gi"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasongi"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason == "gt"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasongt"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual recount"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualrecount"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual received"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualreceived"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual loss"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualloss"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual damage"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualdamage"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual return"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualreturn"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual transfer"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualtransfer"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual initial"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualinitial"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual create lot number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualcreatelotnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual create serial number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualcreateserialnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual update lot number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualupdatelotnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual update serial number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualupdateserialnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual delete lot number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualdeletelotnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual delete serial number"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualdeleteserialnumber"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual consumed production"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ")\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualconsumedproduction"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual received production"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ")\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualreceivedproduction"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.stockactivity.details.reason ==
                                      "manual issue"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.adjustmentstock"
                                                  )
                                                ) +
                                                ") " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "status.inventory.reasonmanualissue"
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    item.stockactivity.details.status == "in"
                                      ? [
                                          _vm._v(
                                            "\n                +" +
                                              _vm._s(
                                                _vm.getNumber(
                                                  item.stockactivity.details
                                                    .quantity
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.stockactivity.details.status == "out"
                                      ? [
                                          _vm._v(
                                            "\n                -" +
                                              _vm._s(
                                                _vm.getNumber(
                                                  item.stockactivity.details
                                                    .quantity
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("router-link-custom", {
                                      attrs: {
                                        to: {
                                          name: "WarehouseEdit",
                                          query: {
                                            id: item.warehouse.warehouse_id,
                                            name: item.warehouse.warehouse_name
                                          }
                                        },
                                        text: item.warehouse.warehouse_name,
                                        to_appid: 3,
                                        current_appid: 3,
                                        disabled:
                                          item.warehouse.is_deleted == true
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.warehouse.bin_code) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    item.stockactivity.details.ref_inventory &&
                                    !item.stockactivity.details.ref_accounting
                                      ? [
                                          item.stockactivity.details
                                            .ref_inventory.gr
                                            ? [
                                                _c("router-link-custom", {
                                                  attrs: {
                                                    to: {
                                                      name: "GoodsReceiptEdit",
                                                      query: {
                                                        gr_id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gr
                                                            .id,
                                                        gr_code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gr
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_inventory.gr.code,
                                                    to_appid: 3,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_inventory.gi
                                            ? [
                                                _c("router-link-custom", {
                                                  attrs: {
                                                    to: {
                                                      name: "GoodsIssueEdit",
                                                      query: {
                                                        gi_id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gi
                                                            .id,
                                                        gi_code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gi
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_inventory.gi.code,
                                                    to_appid: 3,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_inventory.gt
                                            ? [
                                                _c("router-link-custom", {
                                                  attrs: {
                                                    to: {
                                                      name: "GoodsTransferEdit",
                                                      query: {
                                                        gt_id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gt
                                                            .id,
                                                        gt_code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.gt
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_inventory.gt.code,
                                                    to_appid: 3,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_inventory.lot
                                            ? [
                                                _c("router-link-custom", {
                                                  attrs: {
                                                    to: {
                                                      name: "InventoryLotEdit",
                                                      query: {
                                                        id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.lot
                                                            .id,
                                                        code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.lot
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_inventory.lot.code,
                                                    to_appid: 3,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_inventory.ser
                                            ? [
                                                _c("router-link-custom", {
                                                  attrs: {
                                                    to: {
                                                      name:
                                                        "InventorySerialEdit",
                                                      query: {
                                                        id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.ser
                                                            .id,
                                                        code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_inventory.ser
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_inventory.ser.code,
                                                    to_appid: 3,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e()
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.stockactivity.details.ref_accounting
                                      ? [
                                          item.stockactivity.details
                                            .ref_accounting.ps
                                            ? [
                                                _c("router-link-custom", {
                                                  staticStyle: {
                                                    float: "left"
                                                  },
                                                  attrs: {
                                                    to: {
                                                      name:
                                                        "PosTransactionDetail",
                                                      query: {
                                                        ps_id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.ps
                                                            .id,
                                                        ps_code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.ps
                                                            .code,
                                                        ref:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.ps
                                                            .order_number
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_accounting.ps.code,
                                                    to_appid: 1,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_accounting.po
                                            ? [
                                                _c("router-link-custom", {
                                                  staticStyle: {
                                                    float: "left"
                                                  },
                                                  attrs: {
                                                    to: {
                                                      name: "PurchaseOrderEdit",
                                                      query: {
                                                        id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.po
                                                            .id,
                                                        code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.po
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_accounting.po.code,
                                                    to_appid: 4,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.stockactivity.details
                                            .ref_accounting.so
                                            ? [
                                                _c("router-link-custom", {
                                                  staticStyle: {
                                                    float: "left"
                                                  },
                                                  attrs: {
                                                    to: {
                                                      name: "SaleOrderEdit",
                                                      query: {
                                                        so_id:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.so
                                                            .id,
                                                        so_code:
                                                          item.stockactivity
                                                            .details
                                                            .ref_accounting.so
                                                            .code
                                                      }
                                                    },
                                                    text:
                                                      item.stockactivity.details
                                                        .ref_accounting.so.code,
                                                    to_appid: 4,
                                                    current_appid: 3
                                                  }
                                                })
                                              ]
                                            : _vm._e()
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getDateTime(
                                          item.stockactivity.created_at
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      item.user.email || item.user.username
                                    )
                                  )
                                ])
                              ])
                            })
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                839836782
              )
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0122c8be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0122c8be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/activity/List.vue
// module id = null
// module chunks = 